import React from 'react';
interface SectionHeaderProps {
  label: string;
}
export function SectionHeader({
  label
}: SectionHeaderProps) {
  return <div className="flex justify-center relative z-10" data-id="element-281">
      <div className="has-radius bg-white inline-flex items-center justify-center" style={{
      padding: '8px 24px',
      borderRadius: '18px',
      height: '33px'
    }} data-id="element-282">
        <span style={{
        color: '#090909',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '1.125rem',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        textTransform: 'uppercase' as const
      }} data-id="element-283">
          {label}
        </span>
      </div>
    </div>;
}